/**
 * Which meeting is asked to open (TRUS-691) — set by a ?meeting= link, a push
 * click or the upcoming list, possibly before <MeetingsHost> is mounted.
 */

import { useSyncExternalStore } from 'react';

let requested: number | null = null;
const listeners = new Set<() => void>();
export const meetingStore = {
  get: () => requested,
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  open(id: number) {
    requested = id;
    listeners.forEach((l) => l());
  },
  close() {
    if (requested == null) return;
    requested = null;
    listeners.forEach((l) => l());
  },
  /** Tests only. */
  reset() {
    requested = null;
    listeners.forEach((l) => l());
  },
};

export function useRequestedMeetingId(): number | null {
  return useSyncExternalStore(meetingStore.subscribe, meetingStore.get, meetingStore.get);
}

